/* eslint-disable camelcase */
import { pushToDataLayer } from '../pushToDataLayer';

/**
 * Handles the data layer push for activating selector.
 */
export const activateProductSelector = () => {
  pushToDataLayer({
    event: 'ga4_product_selector',
    ga4_data: {
      action_type: 'Start questionnaire',
      step_number: 'N/A',
      step_name: 'N/A',
      answer: 'N/A'
    }
  });
}

/**
 * Handles the data layer push for the continue button click.
 * @param {object} answer - The selected answer object.
 * @param {object} currentStepData - The data object for the step being completed.
 * @param {number} stepHistoryLength - The length of the stepHistory array.
 */
export const handleProductSelectorContinueClick = (answer, currentStepData, stepHistoryLength) => {
  const sequentialStepNumber = stepHistoryLength + 1;
  sessionStorage.setItem('productSelectorStepNumber', sequentialStepNumber);

  pushToDataLayer({
    event: 'ga4_product_selector',
    ga4_data: {
      action_type: 'Continue Button Click',
      step_number: `Step ${sequentialStepNumber}`,
      step_name: currentStepData?.progressBarStepTitle || 'Unknown Step',
      answer: answer?.valueAnalytics || 'N/A'
    }
  });
};

/**
 * Handles the data layer push when a user submits the form or closes it without submitting.
 * @param {string} action - The action type, based on the button clicked on the form.
 */
export const handleProductSelectorForm = (action) => {
  // Adds 1 to the last step number set in sessionStorage ('productSelectorStepNumber').
  // This is because the completion of the form itself is considered +1 step from the last question.
  const sequentialStepNumber = Number(sessionStorage.getItem('productSelectorStepNumber')) + 1;

  pushToDataLayer({
    event: 'ga4_product_selector',
    ga4_data: {
      action_type: action,
      step_number: `Step ${sequentialStepNumber}`,
      step_name: 'Email pop-up',
      newsletter_opt_in: 'false'
    }
  });
}

/**
 * Handles the data layer push when filter page is visible(without form modal).
 */
export const handleProductSelectorResultPage = () => {
  // Adds 2 to the last step number set in sessionStorage ('productSelectorStepNumber').
  // This is because the completion of the form itself is considered +1 step from the last question,
  // and viewing the result page is an additional +1 step after form completion.
  const sequentialStepNumber = Number(sessionStorage.getItem('productSelectorStepNumber')) + 2;

  pushToDataLayer({
    event: 'ga4_product_selector',
    ga4_data: {
      action_type: 'View result page',
      step_number: `Step ${sequentialStepNumber}`,
      step_name: 'View result page',
      answer: 'N/A'
    }
  });
}

/**
 * Handles the data layer push for click on start over link.
 */
export const handleProductSelectorStartOver = () => {
  // Adds 2 to the last step number set in sessionStorage ('productSelectorStepNumber').
  // This is because the completion of the form itself is considered +1 step from the last question,
  // and viewing the result page is an additional +1 step after form completion.
  const sequentialStepNumber = Number(sessionStorage.getItem('productSelectorStepNumber')) + 2;

  pushToDataLayer({
    event: 'ga4_product_selector',
    ga4_data: {
      action_type: 'Start over',
      step_number: `Step ${sequentialStepNumber}`,
      step_name: 'View result page',
      answer: 'N/A'
    }
  });
}
